import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  ACTION_REQUESTED,
  APPROVAL_STATUS,
  EXCHANGE_GONE_OUTRIGHT,
  EXPECTED_COMPONENT,
  EXPECTED_SERIAL_NUMBER,
  INTERNAL_OUTRIGHT,
  ORIGINAL_EVALUATION,
  REPAIR_AND_HOLD_LEAD_TIME,
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_RECEIVED,
  TRANSFER_COST,
  WARRANTY_STATUS
} from "MODULES/RepairOrders/constants";
import _ from "lodash";
import {
  COMPANY,
  DROPSHIP
} from "MODULES/shared/components/ShippingSection/shippingTypes";
import {
  OTHER_TAG_TYPE,
  PART_ID,
  REPAIR_EVALUATION_REJECTED
} from "MODULES/inventories/constants";
import { INVENTORY_ID, QUANTITY, RETURN_TO_TYPE } from "APP_ROOT/constants";
import { LABOR_COST, PART_COST } from "MODULES/SalesOrders/constants";
import { REPAIR_STATION_WARRANTY_STATUS } from "MODULES/RMAsAndWarranties/constants";

const validReturnToForWarranty = (val, props) => {
  const path = "lineItem.inventory.most_recent_customer_rma";
  const creditRequestedRma =
    _.get(props, `${path}.credit_requested`) &&
    _.get(props, `${path}.warranty_consideration`) &&
    !_.get(props, `${path}.closed_date`);

  const code = _.get(props, "lineItem.inventory.most_recent_customer_rma.code");

  if (creditRequestedRma && [COMPANY, DROPSHIP].includes(val)) {
    return `You must first remove the open credit request from Cust ${code} before you can return it to the Customer or an address other than our Store Location/s`;
  }

  return undefined;
};

export default function validate(values, props) {
  return validator(values, form => {
    form
      .validate(ACTION_REQUESTED, PART_ID, APPROVAL_STATUS)
      .satisfies(rules.required);

    if (values.action_requested !== EXPECTED_COMPONENT) {
      form.validate(INVENTORY_ID).satisfies(rules.required);
    }

    if (
      [REPAIR_EVALUATION_APPROVED, REPAIR_EVALUATION_RECEIVED].includes(
        values.approval_status
      ) &&
      values.action_requested !== EXPECTED_COMPONENT
    ) {
      form.validate(ORIGINAL_EVALUATION).satisfies(rules.required);
    }

    if (
      values.customer_rma_id &&
      [REPAIR_EVALUATION_APPROVED, REPAIR_EVALUATION_REJECTED].includes(
        values.approval_status
      )
    ) {
      form
        .validate(WARRANTY_STATUS, REPAIR_STATION_WARRANTY_STATUS)
        .satisfies(rules.required);
    }

    if (values.repair_and_hold) {
      form
        .validate(REPAIR_AND_HOLD_LEAD_TIME)
        .satisfies(rules.isBetween(0, 99), rules.required);
    }

    if (values.insurance_type === "Percent") {
      form
        .validate("percent_insured")
        .satisfies(rules.required, rules.isGreaterThan(0.0));
    }

    if (values.insurance_type === "Amount") {
      form
        .validate("amount_insured")
        .satisfies(rules.required, rules.isGreaterThan(0.0));
    }

    if (values.action_requested === EXPECTED_COMPONENT) {
      if (
        [REPAIR_EVALUATION_APPROVED, REPAIR_EVALUATION_REJECTED].includes(
          values.approval_status
        )
      ) {
        form
          .validate(TRANSFER_COST)
          .satisfies(rules.required, rules.isGreaterThanOrEqualTo(0.0));
      }

      form.validate(EXPECTED_SERIAL_NUMBER, QUANTITY).satisfies(rules.required);
      form.validate(QUANTITY).satisfies(rules.isGreaterThan(0));
    }

    if (values.approval_status === REPAIR_EVALUATION_APPROVED) {
      form.validate(LABOR_COST, PART_COST).satisfies(rules.requiredAllowZero);
    }

    if (values.original_evaluation != null) {
      form.validate(LABOR_COST, PART_COST).satisfies(rules.required);
    }

    if (![EXCHANGE_GONE_OUTRIGHT, INTERNAL_OUTRIGHT].some(f => values[f])) {
      form
        .validate(RETURN_TO_TYPE)
        .satisfies(val => validReturnToForWarranty(val, props));
    }

    if (values.other) {
      form
        .validate(OTHER_TAG_TYPE)
        .satisfies(rules.required, rules.maxLengthOfText(30));
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/validate.js